import React from "react";
import ApproveButton from "@components/FlowActionButtons/ApproveButton";
import { canUserNonDispute } from "./utils";

interface NonDisputeMovementProps {
  movementFlowData?: {
    id: string;
    task: { status: string; claimOwnerName: string } | null;
    status: string;
    terminalReport: { report: string } | null;
    to: string;
    from: string;
  };
  openDrawer: (drawerName: string) => void;
}

const LANG_BASE = "vessel-call.movement-services";

const NonDisputeMovement: React.FC<NonDisputeMovementProps> = ({
  movementFlowData,
  openDrawer,
}) => {
  if (!movementFlowData || !movementFlowData.task) {
    return null;
  }

  const isActionAvailable = canUserNonDispute(
    movementFlowData.task.status,
    movementFlowData.task.claimOwnerName,
    movementFlowData.from,
    movementFlowData.status,
  );
  const handleNonDisputeClick = () => {
    openDrawer("nonDisputeDrawer");
  };

  return (
    <ApproveButton
      langBase={LANG_BASE}
      permission="canNonDisputeMovementService"
      isActionAvailable={isActionAvailable}
      onApprove={handleNonDisputeClick}
    />
  );
};
export default NonDisputeMovement;
